export const isCurrentChatRequest = (
  activeChatId: string | null,
  requestChatId: string,
) => activeChatId === requestChatId;

export const shouldReuseChatRequest = (
  hasActiveRequest: boolean,
  replaceMessages: boolean,
) => hasActiveRequest && !replaceMessages;
